export default __webpack_public_path__ + "static/media/phone-large-629241ae.031758ac.png";